import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import UseAllCategory from '../../CustomHooks/Category/UseAllCategory'
import { Link } from 'react-router-dom'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const CategoryHeader = () => {
  const [searchValue, handleChangeSearchValue, allCategories, loading, pageCount, onPress] = UseAllCategory()
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1400 },
      items: 11
    },
    desktop: {
      breakpoint: { max: 1400, min: 992 },
      items: 8
    },
    tablet: {
      breakpoint: { max: 992, min: 767 },
      items: 6
    },
    mobile: {
      breakpoint: { max: 767, min: 565 },
      items: 3
    },
    extraSmall: {
      breakpoint: { max: 565, min: 0 },
      items: 1
    }
  };

  return (
    <div className="gray-bg py-3 fs-14">
      <Container>
        <Row>
          <Carousel
            responsive={responsive}>
            {allCategories ? (allCategories.map((item, index) => {
              return (
                <div key={index} className='text-center'>
                  <Link to={`/product/category/${item._id}`} className='dark-color text-center'>
                    {item.name}
                  </Link>
                </div>
              )
            })) : <div></div>}
          </Carousel>
        </Row>
      </Container>
    </div>
  )
}

export default CategoryHeader
